<template>
    <div id="om-flyout" :class="menu.active ? 'opened' : ''">
        <div id="om-flyout-items">
            <a v-for="(item, i) in items"
               :key="item.title"
               :href="item.url"
               :class="itemClasses(i)"
               :style="itemStyle(item.bgColor)"
               :onMouseOver="mouseOver(item.bgHoverColor)"
               :onMouseOut="mouseOut(item.bgColor)"
               target="_blank"
               rel="noopener noreferrer"
           >
               <div class="om-flyout-label">{{ item.title }}</div>
               <i :class="iconClass(item.icon)"></i>
            </a>
        </div>
        <a href="#" class="om-flyout-button om-flyout-head" @click.prevent="showOrHide">
            <div class="om-flyout-label">See Quick Links</div>
            <img :src="archie" alt="See Quick Links" />
        </a>
    </div>
</template>
<script lang="js">
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			menu : {
				active : false,
				items  : [
					{
						title        : 'Suggest a Feature',
						url          : this.$urls.app('account/support/?topic=feature&utm_source=WordPress&utm_medium=QuickLinks&utm_campaign=Plugin'),
						icon         : 'fa-lightbulb-o',
						bgColor      : '#007FDB',
						bgHoverColor : '#3FA548',
					},
					{
						title        : 'Join Our Community',
						url          : 'https://www.facebook.com/groups/optinmonsterinnercircle/',
						icon         : 'fa-comments',
						bgColor      : '#007FDB',
						bgHoverColor : '#3FA548',
					},
					{
						title        : 'Support & Docs',
						url          : this.$urls.docs('', 'QuickLinks'),
						icon         : 'fa-life-ring',
						bgColor      : '#007FDB',
						bgHoverColor : '#3FA548',
					},
					{
						title        : 'Upgrade to OptinMonster Pro',
						url          : this.$urls.upgrade({ utm_medium: 'QuickLinks' }),
						icon         : 'fa-star',
						bgColor      : '#F86D37',
						bgHoverColor : '#3FA548',
					},
				],
			},
		}
	},
	computed : {
		...mapGetters([ 'showProUpsells' ]),
		archie () {
			const images = require.context('../../assets/images/', false, /\.svg$/)
			return images(`./${this.menu.active ? '' : 'in'}active-archie.svg`)
		},
		items () {
			const items = [ ...this.menu.items ]
			if (!this.showProUpsells) {
				items.pop()
			}
			return items
		},
	},
	methods : {
		showOrHide () {
			this.menu.active = !this.menu.active
		},
		itemClasses (i) {
			return `om-flyout-button om-flyout-item om-flyout-item-${i}`
		},
		itemStyle (bgColor) {
			return `background-color: ${bgColor}`
		},
		mouseOver (bgHoverColor) {
			return `this.style.backgroundColor='${bgHoverColor}'`
		},
		mouseOut (bgColor) {
			return `this.style.backgroundColor='${bgColor}'`
		},
		iconClass (icon) {
			return `fa ${icon}`
		},
	},
}
</script>
<style scoped lang="scss">
#om-flyout {

	$start: 75px;
	$step: 55px;
	$trans: 0.2s;
	$delay: 35ms;

	position: fixed;
	z-index: 9998;
	transition: all $trans ease-in-out;
	right: 40px;
	bottom: 40px;
	opacity: 1;

	@media all and (max-width:960px) {
		display: none;
	}

	.om-flyout-head {

		display: block;

		img {
            background-color: #fff;
			width: 54px;
			height: 54px;
			display: block;
			border-radius: 50%;
			border: 3px solid #A3C47B;
			overflow: hidden;
			box-shadow: 0 3px 20px rgba(0,0,0,.2);
			transition: all $trans ease-in-out;
		}

		&:hover img {
			box-shadow: 0 3px 30px rgba(0,0,0,.25);
		}

		.om-flyout-label {
			opacity: 0;
			transform: translateY(-50%) scale(0);
			margin-right: -50px;
		}

		&:hover .om-flyout-label {
			opacity: 1;
			transform: translateY(-50%) scale(1);
			margin-right: 0;
		}

		&:focus {
			box-shadow: none;
		}

		.om-flyout-label {
			right: calc(100% + 15px);
		}
	}

	.om-flyout-label {

		position: absolute;
		display: block;
		top: 50%;
		right: calc(100% + 25px);
		transform: translateY(-50%);
		-moz-transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
		color: #fff;
		background: #5F5E5E 0 0 no-repeat padding-box;
		font-size: 12px;
		white-space: nowrap;
		padding: 5px 10px;
		height: auto!important;
		line-height: initial;
		transition: all $trans ease-out;
		border-radius: 3px;
		-moz-border-radius: 3px;
		-webkit-border-radius: 3px;
	}

	.om-flyout-item {

		position: absolute;
		left: 10px;
		width: 40px;
		height: 40px;
		opacity: 0;
		visibility: hidden;
		transition: all $trans ease-in-out;
		transform: scale(0);
		border-radius: 50%;
		box-shadow: 0 3px 20px rgba(0,0,0,.2);
		background: #036AAB 0 0 no-repeat padding-box;
		text-align: center;
		vertical-align: middle;

		i {
			color: #ffffff;
			font-size: 20px;
			line-height: 40px;
			vertical-align: middle;
		}

		@for $i from 0 through 4 {
			&.om-flyout-item-#{$i} {
				bottom: $start + $i * $step;
			}
		}

		&:hover {

			box-shadow: 0 3px 30px rgba(0,0,0,.25);
			background: #0096F0 0 0 no-repeat padding-box;

			.om-flyout-label {
				background: #444444 0 0 no-repeat padding-box;
			}
		}
	}

	&.opened {

		.om-flyout-item {
			opacity: 1;
			visibility: visible;
			transform: scale(1);
		}

		.om-flyout-head {

			.om-flyout-label {
				display: none;
			}
		}

		@for $i from 0 through 4 {
			.om-flyout-item-#{$i} {
				transition: transform $trans $i * $delay, background-color $trans;
			}
		}
	}

	&.out {
		opacity: 0;
		visibility: hidden;
	}
}
</style>
